import type { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { authorizationFilters } from './authorization.filters';

// `validateSearch` de /ccb/gestao-autorizacoes (U07). Leve de propósito: é JS inicial.

/** Página (a partir de 1), tamanho e os filtros do legado. Sem ordenação (o legado não tem). */
export const authorizationSearch = listSearchSchema({ ...authorizationFilters.shape });
export type AuthorizationSearch = z.infer<typeof authorizationSearch>;
